import { Modal } from "../../../../components/Modal";
import { PrimaryButton } from "../../../../components/Buttons";
import { colors } from "../../../../components/colors";
import { useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useFormContext } from "react-hook-form";
import { RejectOrderForm } from "./RejectOrderSelector";
import * as Inputs from "../../../common/hook-form/index";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { getErrorMessage } from "../../../../error-handler";
import { useRejectOrder } from "../service/order-api";

type Props = {
  isOpen: boolean;
  closeModal: () => void;
};

export const RejectOrderConfirmModal = ({ isOpen, closeModal }: Props) => {
  const { id } = useParams<{
    id: string;
  }>();
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);
  const { mutateAsync: rejectOrder, isLoading } = useRejectOrder(id);

  const {
    handleSubmit,
    formState,
    register,
  } = useFormContext<RejectOrderForm>();

  const onSubmit = async (data: RejectOrderForm) => {
    try {
      await rejectOrder({
        organizationKeyName: organization,
        data: {
          reason: data.reason,
          orderId: id!,
        },
      });
      toastr.success("Success", "The order was rejected.");
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      toastr.error("Error", errorMessage);
    } finally {
      closeModal();
    }
  };

  return (
    <Modal
      header="Are you sure?"
      subtitle="You are about to reject this order. Enter reason to continue"
      isOpen={isOpen}
      onClose={closeModal}
    >
      <form>
        <Inputs.InputFormField
          errors={formState.errors}
          register={register}
          label="Rejection reason"
          name="reason"
          helpText="Enter reason for rejection to continue"
        />
        <PrimaryButton
          color={colors.white}
          backgroundColor={colors.errorDark}
          hoverColor={colors.errorMedium}
          onClick={handleSubmit(onSubmit)}
          type="button"
          width="100%"
        >
          {isLoading ? (
            <FontAwesomeIcon icon={solid("spinner")} spin pulse />
          ) : (
            "Reject order"
          )}
        </PrimaryButton>
      </form>
    </Modal>
  );
};
